import React, { lazy, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { ProtectedRoute, LinearDeterminateProgress } from 'components'
import { AppLayout } from 'layout'

import { LoginPage } from 'modules'

const CustomerListPage = lazy(
  () => import('modules/customers/pages/list/CustomerList')
)
const CreateCustomerPage = lazy(
  () => import('modules/customers/pages/create/CreateCustomer')
)
const CustomerDetailsPage = lazy(
  () => import('modules/customers/pages/details/CustomerDetails')
)
const CreateOrderPage = lazy(
  () => import('modules/orders/pages/create/CreateOrder')
)

const EditOrderPage = lazy(() => import('modules/orders/pages/edit/EditOrder'))
const DuplicateOrderPage = lazy(
  () => import('modules/orders/pages/duplicate/DuplicateOrder')
)
const OrderListPage = lazy(() => import('modules/orders/pages/list/OrdersList'))
const OrderDetailsPage = lazy(
  () => import('modules/orders/pages/details/OrderDetails')
)
const ProposalDetailsPage = lazy(
  () => import('modules/orders/pages/details/ProposalDetailsPage')
)
const ReportsPage = lazy(() => import('modules/reports/Reports'))
const CommissionsReportPage = lazy(
  () => import('modules/reports/commissions/CommissionsReport')
)
const DebtsReportPage = lazy(() => import('modules/reports/debts/DebtsReport'))
const AbcClientsReportPage = lazy(
  () => import('modules/reports/abcClients/AbcClientsReport')
)
const AbcProductsReportPage = lazy(
  () => import('modules/reports/abcProducts/AbcProductsReport')
)
const OrdersReportPage = lazy(
  () => import('modules/reports/orders/OrdersReport')
)
const UserList = lazy(() => import('modules/administrator/pages/list/UserList'))
const CreateUserPage = lazy(
  () => import('modules/administrator/pages/create/CreateUser')
)
const EditUserPage = lazy(
  () => import('modules/administrator/pages/edit/EditUser')
)
const SettingsPage = lazy(() => import('modules/setting/Setting'))

const FinancialPage = lazy(() => import('modules/financial/Financial'))

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        element={
          <AppLayout>
            <Suspense
              fallback={
                <LinearDeterminateProgress
                  style={{
                    width: '100%'
                  }}
                />
              }
            >
              <ProtectedRoute />
            </Suspense>
          </AppLayout>
        }
      >
        <Route path="customers" element={<CustomerListPage />} />
        <Route path="customers/create" element={<CreateCustomerPage />} />
        <Route path="customers/:id/details" element={<CustomerDetailsPage />} />
        {/* <Route path="proposals" element={<ProposalList />} />
        <Route path="orders/create" element={<CreateProposalPage />} />
        <Route path="orders/:id/details" element={<ProposalDetailsPage />} />
        <Route path="orders/:id/edit" element={<EditProposalPage />} /> */}
        <Route path="orders" element={<OrderListPage />} />
        <Route path="orders/create" element={<CreateOrderPage />} />
        <Route path="orders/:id/duplicate" element={<DuplicateOrderPage />} />
        <Route path="/orders/web/:id/edit" element={<EditOrderPage />} />
        <Route
          path="/orders/web/:id/details"
          element={<ProposalDetailsPage />}
        />
        <Route path="orders/:id/details" element={<OrderDetailsPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="reports/orders" element={<OrdersReportPage />} />
        <Route path="reports/commissions" element={<CommissionsReportPage />} />
        <Route path="reports/debts" element={<DebtsReportPage />} />
        <Route path="reports/abc/clients" element={<AbcClientsReportPage />} />
        <Route
          path="reports/abc/products"
          element={<AbcProductsReportPage />}
        />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="financial" element={<FinancialPage />} />
        <Route path="users" element={<UserList />} />
        <Route path="users/create" element={<CreateUserPage />} />
        <Route path="/users/:id/edit" element={<EditUserPage />} />
        <Route path="*" element={<Navigate to="/orders" />} />
      </Route>

      <Route path="/login" element={<LoginPage />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  )
}
